import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method apiLogin
 * @method apiLogout
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} username
     * @param {String} password
     * @param {String} strUUID
     * @param {String} strDeviceToken
     * @param {String} strClientVersion
     * @param {Boolean} isDeviceNotiEnable
     */
    apiLogin: function(username, password, strUUID, strDeviceToken, strClientVersion, isDeviceNotiEnable) {
        var params = {
            username: username,
            password: password,
            uuid: strUUID,
            app_id: this.config().client_id,
            os: "web",
            platform: "web",
            mac_address: strUUID,
            device_noti_enable: isDeviceNotiEnable,
            client_version: strClientVersion,
            device_token: strDeviceToken,
        };

        // var url = this.config().bzbsUrl + "/api/auth/bzbs_login";
        var url = this.config().newBzbsUrl + "/auth/bzbs_login";
        return BzbsApi.connectBzbsPost(url, null, params);
    },

    /**
     * @param {String} strBzbsToken
     * @param {String} strFBToken
     * @param {String} strUUID
     */
    apiLogout: function(strBzbsToken, strFBToken, strUUID) {
        var params = {
            uuid: strUUID,
            access_token: strFBToken,
        };

        // var url = this.config().bzbsUrl + "/api/auth/logout";
        var url = this.config().newBzbsUrl + "/auth/logout";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params);
    },

    /**
     * @param {String} strBzbsToken
     * @param {String} strFBToken
     * @param {String} strUUID
     */
    apiResume: function(strBzbsToken) {
        var params = {
        };

        // var url = this.config().bzbsUrl + "/api/auth/device_resume";
        var url = this.config().newBzbsUrl + "/auth/device_resume";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params);
    },
    apiLoginLine: function(lineIdToken) {
        var params = {
            app_id: this.config().client_id,
            id_token: lineIdToken,
        };
        // var url = this.config().bzbsUrl + "/api/auth/line_login";
        var url = this.config().newBzbsUrl + "/auth/line_login";
        return BzbsApi.connectBzbsPost(url, null, params);
    },
    apiErrorLog: function(error, date, osname, lineversion, ua, remark) {
        var params = {
            errorResults: error,
            date: date,
            os: osname,
            lineVersion: lineversion,
            userAgent: ua,
            function : 'init, line97',
            remark: remark
        };
        // var url = this.config().bzbsUrl + "/modules/Chanel/main/log";
        var url = this.config().newBzbsModuleUrl + "/main/log";
        return BzbsApi.connectBzbsPost(url, null, params);
    },
    apiFreeLog: function(params) {
        // var param = {
        //     json: params
        // }
        // var url = this.config().bzbsUrl + "/modules/chanel/main/freelog";
        var url = this.config().newBzbsModuleUrl + "/main/freelog";
        return BzbsApi.connectBzbsPostJson(url, null, params);
    },
}
